import {twMerge} from '../../../common/twMerge';
import {VideoStatus} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/videoViewerConstant';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Loading} from '../../atoms/Loading/Loading';
import {VideoPlayerControllerProps} from './VideoPlayerControllerProps.interface';

export function VideoPlayerController({
  isVideoVisible,
  isShortsDrama,
  isMobile,
  isShowTimeMoveBtn,
  isLoading,
  videoStatus,
  onClickPrevMoveBtn,
  onClickNextMoveBtn,
  onClickPlayBtn,
  onClickReplayBtn,
  onClickPauseBtn,
}: VideoPlayerControllerProps) {
  return (
    <div
      className={twMerge(
        'absolute top-1/2 left-1/2 flex h-80pxr w-204pxr items-center justify-between',
        !isLoading &&
          videoStatus === VideoStatus.Ended &&
          !isMobile &&
          'w-80pxr',
        !isMobile &&
          'rounded-[16px] bg-[rgb(var(--colors-static-mono-black)_/_80%)]',
        isShortsDrama && !isMobile && 'w-auto',
        isShortsDrama && isMobile && isVideoVisible && 'hidden'
      )}
      style={{
        transform: 'translate(-50%, -50%)',
      }}
      {...putTiaraObjectProps({
        click: {
          layer2: '재생컨트롤러',
        },
      })}
    >
      <div
        className={twMerge(
          'flex w-full flex-row items-center justify-center',
          isShowTimeMoveBtn && !isShortsDrama && 'justify-between',
          !isMobile && 'px-20pxr'
        )}
      >
        {isShowTimeMoveBtn && !isShortsDrama && (
          <Icon
            type={IconType.Viewer10sPrevStatic}
            onClick={onClickPrevMoveBtn}
            className="cursor-pointer"
          />
        )}
        {isLoading && <Loading />}
        {!isLoading && videoStatus === VideoStatus.Playing && (
          <Icon
            type={IconType.ViewerPauseStatic}
            onClick={onClickPauseBtn}
            className="cursor-pointer"
            {...putTiaraObjectProps({
              click: {
                copy: '일시정지',
              },
            })}
          />
        )}
        {!isLoading &&
          (videoStatus === VideoStatus.Paused ||
            videoStatus === VideoStatus.BeforeInitialPlay) && (
            <Icon
              type={IconType.ViewerPlayStatic}
              onClick={onClickPlayBtn}
              className="cursor-pointer"
              {...putTiaraObjectProps({
                click: {
                  copy: '재생',
                },
              })}
            />
          )}
        {!isLoading && videoStatus === VideoStatus.Ended && (
          <Icon
            type={
              isShortsDrama
                ? IconType.ViewerPlayStatic
                : isMobile
                  ? IconType.ViewerReplayStatic
                  : IconType.ViewerReplayPcStatic
            }
            onClick={onClickReplayBtn}
            className="cursor-pointer"
          />
        )}
        {isShowTimeMoveBtn && !isShortsDrama && (
          <Icon
            type={IconType.Viewer10sNextStatic}
            onClick={onClickNextMoveBtn}
            className="cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}
